import React, { Component, Suspense } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Route, Switch, withRouter, Redirect } from 'react-router-dom';
import { Loading } from '@tencent/ten-design-react';
import styles from './index.less';
import routers from '@pc/router/index';
// import store from '@pc/models/store';
import BaseView from './baseView';
import { path2Params } from '@shared/utils';
import i18next from 'i18next';
import { EventBus } from '@shared/service';

@connect(null, (dispatch) => ({
  dispatch: dispatch.auth,
}))
@withRouter
class AuthProvider extends Component {
  static propTypes = {
    children: PropTypes.node,
    dispatch: PropTypes.object,
  };

  constructor(props) {
    super(props);

    this.state = {
      isLoading: true,
    };
  }

  componentDidMount() {
    this.getUserAuth();

    this.init();
  }

  init() {
    this.checkLanguage();
    this.props.history.listen(() => {
      this.checkLanguage();
    });

    // 注册event事件
    EventBus.on('permissionDenied', ({ title, content }) => {
      this.props.history.replace('/notFound', { title, content });
    });
  }

  getUserAuth() {
    const { dispatch, location } = this.props;
    const currentRouter = routers.find((router) => router.path === location.pathname);
    // console.log(currentRouter);
    let needAuth = true;
    if (currentRouter && currentRouter.auth === false) {
      needAuth = false;
    }

    // 无需登录状态校验时，直接渲染页面
    if (!needAuth) {
      this.setState({
        isLoading: false,
      });
    } else {
      dispatch.getUser().then(() => {
        this.setState({
          isLoading: false,
        });
      });
    }
  }

  checkLanguage() {
    const { history: { location: { search = '' } = {} } = {} } = this.props;
    const { lang = '' } = path2Params(search);
    // 判断是否存在这个语言
    // console.log(i18next?.languages);
    if (i18next?.languages?.includes(lang)) {
      i18next.changeLanguage(lang).then(
        () => {
          console.log(`切换语言: ${lang}`);
        },
        (err) => {
          console.error(err);
        },
      );
    }
  }

  render() {
    // const {
    //   auth: { isAuthenticated },
    // } = store.getState();
    const { isLoading } = this.state;

    const authRouter = routers.map((route, index) => {
      const { component: Component, auth = true } = route;

      return auth ? (
        <Route
          key={index}
          exact={route.exact}
          strict={route.strict}
          path={route.path}
          render={(props) =>
            route.path === '/' ? (
              <Redirect path="/" to="/document" />
            ) : (
              <BaseView {...props} {...route}>
                <Component />
              </BaseView>
            )
          }
        />
      ) : (
        <Route
          key={index}
          exact={route.exact}
          strict={route.strict}
          path={route.path}
          render={(props) => <Component {...props} />}
        />
      );
    });

    return (
      <React.Fragment>
        <div className={styles.pageContainer}>
          <div className={styles.contents}>
            {isLoading ? (
              <div className={styles.authLoading}>
                <Loading />
              </div>
            ) : (
              <>
                <Suspense fallback={<Loading />}>
                  <Switch>{authRouter}</Switch>
                </Suspense>
              </>
            )}
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default AuthProvider;
